"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.CURRENCY_MASK_CONFIG = new core_1.InjectionToken("currency.mask.config");
//# sourceMappingURL=currency-mask.config.js.map


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/ng2-currency-mask/src/currency-mask.config.js
// module id = ../../../../ng2-currency-mask/src/currency-mask.config.js
// module chunks = 4